import { debounce } from 'lodash';
import cx from 'classnames';
import { useHistory } from 'react-router';
import useHover from 'react-use-hover';
import React, { useRef, useContext } from 'react';

import Context from '../Context';
import TodoSimple from '~/App/Components/Todo/Simple';
import { Profile } from '~/types/models';
import { useMedia } from 'react-use-media';

export type TodoItemProps = {
  id: string;
  className?: string;
  selected: boolean;
  profiles: Profile[];
  reason?: string;
  timestamp: string;
  icons?: React.ReactNode;
  onClick: () => void;
};

function TodoItem({ id, ...otherProps }: TodoItemProps) {
  const checkboxRef = useRef();
  const { bulkSelect } = useContext(Context);
  const checked = bulkSelect.isChecked(id);
  const isMobile = useMedia({
    maxWidth: 768,
  });
  const history = useHistory();

  const bulkSelectCount = bulkSelect.data.count;
  const anyChecked = bulkSelect.data.any;

  const [containerHovered, containerProps] = useHover({ mouseEnterDelayMS: 0 });
  const [checkboxContainerHovered, checkboxContainerProps] = useHover({
    mouseEnterDelayMS: 0,
  });

  const showCheckbox =
    checked ||
    (!isMobile && containerHovered) ||
    (isMobile && checkboxContainerHovered) ||
    anyChecked;

  function toggleChecked() {
    const { check, uncheck } = bulkSelect;

    checked ? uncheck(id) : check(id);
  }

  const toggleCheckedDebounced = debounce(toggleChecked, 50);
  function handleCheckboxClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    toggleCheckedDebounced();

    if (bulkSelectCount === 1 && checked) {
      history.replace('/home');
    } else {
      history.replace('/home/bulk-select');
    }
  }

  return (
    <div className='relative' {...containerProps}>
      <TodoSimple {...otherProps} />
      <div
        className={cx(
          'flex top-px left-px w-[72px] z-[5] h-[70px] pl-2 absolute flex items-center justify-center',
          {
            'bg-white/[0.5]': showCheckbox,
            hidden: !showCheckbox,
          }
        )}
        onClick={handleCheckboxClick}
        {...checkboxContainerProps}
      >
        <input
          className='w-4 h-4 !m-0'
          type='checkbox'
          ref={checkboxRef}
          checked={checked}
          onChange={handleCheckboxClick}
        />
      </div>
    </div>
  );
}

export default TodoItem;
